import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

const withLocation = (WrappedComponent) => {
    const WithLocation = (props) => {
        const location = useLocation();
        const navigate = useNavigate();
        const params = useParams();
        return <WrappedComponent {...props} location={location} navigate={navigate}params={params} />;
    };
    WithLocation.initialAction = WrappedComponent.initialAction;
    return WithLocation;
};

export default withLocation;
